export default function addFacet(name, value) {
	const { facets } = this.state

	const existingFacet = facets.find(f => f.field === `f_${name}`) || {}
	const allOtherFacets = facets.filter(f => f.field !== `f_${name}`) || []
	const existingFacetValues = existingFacet.values || []

	const newFacetValues = existingFacetValues.find(existing => existing && existing === value)
		? existingFacetValues
		: existingFacetValues.concat(value)

	this._updateSearchResults({
		pageNumber: 1,
		facets: [...allOtherFacets, { field: `f_${name}`, values: newFacetValues }],
	})
}
